import { Common } from './common'
import { Errors } from './errors'
import { Login } from './views/Login'
import { ForgotPassword } from './views/ForgotPassword'
import { CreateAccount } from './views/CreateAccount'
import { DashboardMenu } from './components/DashboardMenu'
import { Orders } from './components/Orders'
import { OrdersTag } from './components/OrdersTag'
import { ModalActions } from './components/ModalActions'
import { Admin } from './components/Admin'
import { OrderTableFilter } from './components/OrderTableFilter'
import { DashboardDelivery } from './components/DashboardDelivery'
import { DashboardIncidences } from './components/DashboardIncidences'
import { DashboardEDF } from './components/DashboardEDF'
import { DashboardEDD } from './components/DashboardEDD'
import { DashboardAdmin } from './components/DashboardAdmin'
import { NewPartner } from './miscellaneous/NewPartner'
import { NewVehicle } from './miscellaneous/NewVehicle'
import { ListVehicle } from './miscellaneous/ListVehicle'
import { ModalMessages } from './components/ModalMessages'
import { OrderFilter } from './components/OrderFilter'
import { StoreFilter } from './components/StoreFilter'
import { OrderStatesFilter } from './components/OrderStatesFilter'
import { Filters } from './components/Filters'

export const pt = {
  Common,
  Errors,
  Login,
  ForgotPassword,
  CreateAccount,
  DashboardMenu,
  Orders,
  OrdersTag,
  ModalActions,
  Admin,
  OrderTableFilter,
  DashboardDelivery,
  DashboardIncidences,
  DashboardEDF,
  DashboardEDD,
  DashboardAdmin,
  NewPartner,
  NewVehicle,
  ListVehicle,
  ModalMessages,
  OrderFilter,
  StoreFilter,
  OrderStatesFilter,
  Filters
}



// WEBPACK FOOTER //
// ./src/translations/pt/index.js